import { Component, OnInit } from '@angular/core';
import { AppConstants } from 'src/app-constants';
import { TokenRequestSM } from 'src/app/service-models/token/token-request-s-m';
import { CommonService } from 'src/app/services/common.service';
import ContactUsService from 'src/app/services/contact-us.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { ContactUsViewModel } from 'src/app/view-models/contact-us.viewmodel';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent extends BaseComponent<ContactUsViewModel> implements OnInit {

  constructor(private contactUsService: ContactUsService,
    commonService: CommonService, logService: LogHandlerService) {
      super(commonService, logService);
      this.viewModel = new ContactUsViewModel();
      
    }

  async ngOnInit(): Promise<void> {
  }


  async sendContactUsForm() {
    try {
      await this._commonService.presentLoading();
      //have to do paging
      let resp = await this.contactUsService.contactUs(this.viewModel.singleContact);
      if (resp.isError) {
        this._exceptionHandler.logObject(resp.errorData);
        this._commonService.presentToast({
          header: 'Error!',
          body: resp.errorData.displayMessage, delay: 5000,
          className: 'TopRight bg-danger text-light', animation: true
        });
      }
      else {
        if (resp.successData != null)
          this.viewModel.singleContact = resp.successData;
      }
    } catch (error) {
      this._commonService.presentToast({
        header: 'Error!',
        body: AppConstants.ErrorPrompts.Unknown_Error, delay: 5000,
        className: 'TopRight bg-danger text-light', animation: true
      });
      throw error;
    }
    finally {
      await this._commonService.dismissLoader()
    }
  }
}